import { addToCart } from './_atc';
export default function initOffers(component, formAddToCartOffers) {
  for (let form of formAddToCartOffers) {
    form.addEventListener('submit', addToCart.bind(component, form));
  }
  const showOffersListButtons = document.querySelectorAll(".js-popin-show-offer-list--button");
  showOffersListButtons.forEach(button => button.addEventListener('click', () => {
    import(/* webpackChunkName: "OffersLayer" */"@mozaic-ds/freemarker/js/modules/_layer.js").then(module => {
      component.popinOffersList = new module.default({
        'classContent': "js-popin-show-offer-list"
      });
      component.popinOffersList.open();
      _showAllDeliveriesModes(component);
    }).catch(console.error);
  }));
}
function _showAllDeliveriesModes(component) {
  const showDeliveriesButtons = component.target.querySelectorAll(".js-show-all-deliveries");
  [...showDeliveriesButtons].forEach(button => {
    button.addEventListener('click', event => {
      const allDeliveriesContent = button.parentElement.querySelector('.js-all-deliveries');
      allDeliveriesContent.classList.remove('kl-hidden');
      button.classList.add('kl-hidden');
    });
  });
}